<template>
  <v-app id="app" class="mx-auto">
    <Welcome v-if="!isLoggedIn" />
    <LoggedInView v-if="isLoggedIn" :userinfowrapper="userInfoWrapper" />
  </v-app>
</template>

<script>
import Welcome from "./components/Welcome.vue";
import LoggedInView from "./components/LoggedInView.vue";

export default {
  name: "App",
  components: {
    Welcome,
    LoggedInView
  },
  computed: {
    isLoggedIn: function() {
      return this.userInfoWrapper.UserInfo != null;
    }
  },
  data() {
    return {
      userInfoWrapper: { UserInfo: null }
    };
  },
  created: async function() {
    try {
      this.userInfoWrapper.UserInfo = await getLoggedInUserInfo();
      // alert(`this.userInfoWrapper.UserInfo is ${JSON.stringify(this.userInfoWrapper.UserInfo)}`);
    } catch (e) {
      console.log(`Failed to get logged-in user info: ${e.toString()}`);
    }
  }
};

// https://reading.ashishb.net
const userInfoEndpoint = "/v1/userinfo";
const mockResponse = false;

async function getLoggedInUserInfo() {
  if (mockResponse) {
    return JSON.parse(
      "" +
        "{\n" +
        '    "DisplayName": "Ashish Bhatia",\n' +
        '    "FeedItemCount": -1,\n' +
        '    "FeedURL": "https://rss.app/feeds/hmsyAr3PyniBpmOd.xml"\n' +
        "  }"
    );
  }
  const response = await fetch(userInfoEndpoint, {
    // mode: "cors"
  });
  if (response.status === 200) {
    return await response.json();
  }
  if (response.status === 302) {
    console.log("Received a redirect, user is logged-out");
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
